import { useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import { getHealth } from "./api/client";
import { ArcProvider } from "./state/arc";
import WelcomeBeats from "./screens/WelcomeBeats";
import ToolkitReflected from "./screens/ToolkitReflected";
import ToolkitPanel from "./screens/ToolkitPanel";
import ScriptUpload from "./screens/ScriptUpload";
import ImportScreen from "./screens/Import";
import CharacterPick from "./screens/CharacterPick";
import BuildingRoom from "./screens/BuildingRoom";
import RehearsalRoom from "./screens/RehearsalRoom";
import ScriptWithCallouts from "./screens/ScriptWithCallouts";
import RecordingRoom from "./screens/RecordingRoom";
import Library from "./screens/Library";
import NavChrome from "./components/NavChrome";
import { RecordingBoothScreen } from "./screens/RecordingBoothScreen";
import { RunLinesScreen } from "./screens/RunLinesScreen";
import { ShelfScreen } from "./screens/ShelfScreen";
import { RehearsalRoomScreen } from "./screens/RehearsalRoomScreen";
import { FullCanvas } from "./components/FullCanvas";
import RehearsalApp from "./screens/RehearsalApp";

function ArcShell() {
  // Health check still useful for dev — kept silent so it doesn't draw a
  // dark legacy header on every cream surface. NavChrome owns the visible
  // top header now.
  useEffect(() => {
    getHealth().catch(() => { /* silent */ });
  }, []);
  return <Outlet />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ArcProvider>
        <Routes>
          <Route element={<ArcShell />}>
            <Route index element={<Navigate to="/library" replace />} />
            <Route path="/library" element={<RehearsalApp />} />
            <Route path="/rehearsal" element={<RehearsalApp />} />
            <Route path="/library-v2" element={<FullCanvas><ShelfScreen /></FullCanvas>} />
            <Route path="/library-v0" element={<NavChrome><Library /></NavChrome>} />
            <Route path="/welcome" element={<WelcomeBeats />} />
            <Route path="/toolkit" element={<ToolkitReflected />} />
            <Route path="/confirm" element={<NavChrome><ToolkitPanel /></NavChrome>} />
            <Route path="/upload" element={<ScriptUpload />} />
            <Route path="/import" element={<ImportScreen />} />
            <Route path="/character" element={<NavChrome><CharacterPick /></NavChrome>} />
            <Route path="/building" element={<BuildingRoom />} />
            <Route path="/room" element={<FullCanvas><RehearsalRoomScreen /></FullCanvas>} />
            <Route path="/room-v0" element={<NavChrome><RehearsalRoom /></NavChrome>} />
            <Route path="/script" element={<NavChrome><ScriptWithCallouts /></NavChrome>} />
            <Route path="/record" element={<FullCanvas><RecordingBoothScreen /></FullCanvas>} />
            <Route path="/record-v0" element={<NavChrome><RecordingRoom /></NavChrome>} />
            <Route path="/run-lines" element={<FullCanvas><RunLinesScreen /></FullCanvas>} />
            <Route path="*" element={<Navigate to="/library" replace />} />
          </Route>
        </Routes>
      </ArcProvider>
    </BrowserRouter>
  );
}
